import {styled} from '@linaria/react';

export const BlurredOverlay = styled.div<{
  $enableBlur?: boolean;
  $zIndex?: number;
}>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-tap-highlight-color: transparent;

  z-index: ${({$zIndex}) => $zIndex ?? ''};
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: ${({$enableBlur}) => ($enableBlur ? 'blur(4px)' : '')};
`;
